import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './SingleView.module.scss';
import cn from 'classnames';
import Stable from '../StableView/Stable/Stable';
import { ReactComponent as ArrowLeft } from '../../assets/icons/arrow-left.svg';
import { ReactComponent as Heart } from '../../assets/icons/heart.svg';
import IconWithText from '../../components/IconWithText/IconWithText';
import { ReactComponent as StarStable } from '../../assets/icons/star-stable.svg';
import Heading from '../../components/Typography/Heading/Heading';
import { ReactComponent as FlagIcon } from '../../assets/icons/flag-icon.svg';
import Button from '../../components/Button/Button';
import { setActiveStableButton } from '../../store/reducers/Stable/tabs';
import HorseTabs from '../../components/HorseTabs/HorseTabs';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../store/reducers';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Tooltip from '../../components/Tooltip/Tooltip';
import { Routes } from '../../constants/routes';
import { setStableDetailsNavigateBackRoute } from '../../store/reducers/Stable/slice';
import { displayName } from '../../components/LabelBox/LabelBox';
import { getFriendStatus } from '../../store/reducers/Social/slice';
const SingleView = ({ horse, buttons, tabs, jockey, className, onClick, activeTab, horseClassName }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [stableName, setStableName] = useState('');
    const { pathname } = useLocation();
    const param = useParams();
    const navigate = useNavigate();
    const activeStableButton = useAppSelector((state) => state.stableTab.activeStableButton);
    const friendStatus = useAppSelector((state) => state.social.friendStatus);
    const address = useAppSelector((state) => state.wallet.activeWallet.address);
    const stableElementHeight = useAppSelector((state) => state.iframe.stableElementHeight);
    const stableDetailsNavigationBackRoute = useAppSelector((state) => state.stable.stableDetailsNavigationBackRoute);
    const SingleVieWRef = useRef(null);
    useEffect(() => {
        param.stakeId && param.stakeId !== address
            ? setStableName(`Stable of ${param.stakeId}`)
            : setStableName(t('my_stable'));
    }, [param, t, address]);
    useEffect(() => {
        if (param.stakeId && param.stakeId !== address) {
            setStableName(displayName((friendStatus === null || friendStatus === void 0 ? void 0 : friendStatus.name) || '', (friendStatus === null || friendStatus === void 0 ? void 0 : friendStatus.address) || ''));
        }
        else {
            setStableName(t('my_stable'));
        }
    }, [address, param, t, friendStatus]);
    useEffect(() => {
        if (param.stakeId) {
            dispatch(getFriendStatus(param.stakeId));
        }
    }, []);
    //This is for if user comes from url or refreshes this view
    useEffect(() => {
        if (param.stakeId) {
            let route;
            if (stableDetailsNavigationBackRoute === null || stableDetailsNavigationBackRoute === void 0 ? void 0 : stableDetailsNavigationBackRoute.includes('list')) {
                if (pathname.includes('jockey')) {
                    route = Routes.STABLES_LIST_JOCKEYS_STAKE_ID.replace(':stakeId', param.stakeId);
                }
                else {
                    route = Routes.STABLES_LIST_HORSES_STAKE_ID.replace(':stakeId', param.stakeId);
                }
            }
            else {
                route = Routes.STABLES_STAKE_ID.replace(':stakeId', param.stakeId);
            }
            dispatch(setStableDetailsNavigateBackRoute(route));
        }
    }, []);
    //Handling Proper Navigation back
    const navigateHandler = useCallback(() => {
        if (pathname === stableDetailsNavigationBackRoute) {
            if (param.stakeId) {
                const route = Routes.STABLES_STAKE_ID.replace(':stakeId', param.stakeId);
                navigate(route);
            }
            else {
                navigate(Routes.STABLES);
            }
        }
        else {
            if (stableDetailsNavigationBackRoute) {
                navigate(stableDetailsNavigationBackRoute);
            }
            else {
                navigate(Routes.STABLES);
            }
        }
    }, [pathname, stableDetailsNavigationBackRoute]);
    const tooltipText = (stableDetailsNavigationBackRoute === null || stableDetailsNavigationBackRoute === void 0 ? void 0 : stableDetailsNavigationBackRoute.includes('list'))
        ? 'Go to List View'
        : 'Go to Stable View';
    return (_jsx("div", Object.assign({ ref: SingleVieWRef, className: cn(styles.element) }, { children: _jsxs("div", Object.assign({ className: cn(className, styles.wrapper, 'd-flex flex-column') }, { children: [_jsxs(Stable, Object.assign({ className: cn(styles.stable, horse && styles['isHorseView']) }, { children: [_jsxs("div", Object.assign({ className: cn(styles.icons, 'd-flex align-items-center justify-content-between') }, { children: [_jsx(Tooltip, Object.assign({ content: tooltipText }, { children: _jsx(ArrowLeft, { "data-testid": 'test', className: styles.arrow, onClick: navigateHandler }) })), _jsx(Heart, { className: styles.heart })] })), _jsx(IconWithText, { className: styles.desc, text: stableName, icon: param.stakeId && param.stakeId !== address ? _jsx(_Fragment, {}) : _jsx(StarStable, {}) }), jockey ? (_jsx(_Fragment, { children: _jsx(Heading, { fontWeight: 500, size: 2, className: !jockey ? styles.heading : styles.jockeysHeading, title: (jockey === null || jockey === void 0 ? void 0 : jockey.displayName) || '' }) })) : (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: 'position-relative' }, { children: [_jsx(Heading, { fontWeight: 500, size: 2, className: styles.heading, title: (horse === null || horse === void 0 ? void 0 : horse.static.displayName) || '' }), _jsx(FlagIcon, { className: styles.flag })] })) })), _jsx("div", Object.assign({ className: cn(styles.buttons) }, { children: buttons.map(({ name, disabled }) => (_jsx(Button, { onClick: () => dispatch(setActiveStableButton(!activeStableButton)), color: disabled ? 10 : 1, size: '100', height: 'sm', text: name }, name))) }))] })), _jsx(HorseTabs, { className: horseClassName, activeTab: activeTab, onClick: onClick, jockey: true, tabs: tabs })] })) })));
};
export default SingleView;
